import { computed, type ComputedRef, ref } from 'vue';
import { useI18n } from '@/core/plugins/i18n';
import type { Props, SearcherByKey } from '../types';
import type { Option, Options } from '@/components/forms/select/types';
import { dummyIndex, searhcerCompareKey } from '../utils/consts';
import { getSearcherGIcon } from '@/core/utils/searchers';

/**
 * Создание и управление реактивными переменными для выбора ПС
 *
 * @param props - входные props компонента
 * @param mapSearchers - Map ПС (реактивная)
 */
export const useSelectSearcher = (
	props: Props,
	mapSearchers: ComputedRef<SearcherByKey>,
) => {
	const i18n = useI18n();

	/**
	 * Ключ выбранной поисковой системы
	 */
	const searcherKey = ref(mapSearchers.value.keys().next().value ?? dummyIndex);

	/**
	 * Коллекция опций для выбора ПС
	 */
	const optionBySearcherKey = computed(() => {
		const res: Options = new Map();
		mapSearchers.value.forEach((searcher) => {
			let option: Option = {
				value: searcher.key,
				title: searcher.name,
			};

			if (props.addSearcherIcon) option.icon = getSearcherGIcon(searcher.key);

			res.set(searcher.key, option);
		});

		// добавить режим сравнения, если есть хотя бы одна ПС с одним регионом
		if (props.addCompare && !res.has(dummyIndex)) {
			const dummyOption: Option = {
				value: '',
				title: '--------------------',
				disabled: true,
			};
			res.set(dummyOption.value, dummyOption);

			const compareOption: Option = {
				value: searhcerCompareKey,
				title: i18n.Common.Compare!,
			};
			res.set(compareOption.value, compareOption);
		}

		return res;
	});

	return {
		searcherKey,
		optionBySearcherKey,
	};
};
